import React from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { AutoComplete, SelectField, MenuItem, TextField, Checkbox } from 'material-ui';

class EditAddDialog extends React.Component {
    render() {
        let { 
            openEditDialog, 
            openAddDialog,
            handleCloseDialog,
            vessels,
            ports,
            countries,
            vesselTypes,
            pdaEditAdd: {
                _id,
                approved,
                averagePortCostsUsdDay,
                param: { country, port, vessel, dwt, ourGroup },
            },
            changeVesselAutoComplete,
            chooseVesselAutoComplete,
            handleSelectVesselType,
            handleChangeDwt,
            handleChangePda,
            handleSelectCountry,
            changePortName,
            choosePort,
            handleCheckConfirmed,
            handleRateEditAdd,
            shouldShowConfirmCheckbox,
        } = this.props;

        if(vessel.imoNumber && !vessel.name.includes(' (')) {
            vessel.name = `${vessel.name} (${vessel.imoNumber})`
        }
        
        const editActions = [
            <FlatButton
                label="Cancel"
                primary={true}
                onClick={() => handleCloseDialog(openEditDialog ? 'edit' : 'add')}
            />,
            <FlatButton
                label="Save"
                primary={true}
                onClick={() => handleRateEditAdd(openEditDialog ? 'edit' : 'add')}
            />,
        ];
        
        return (
            <div className='row'>
                <Dialog
                    title={openEditDialog ? 'Edit pda' : 'Add pda'}
                    open={openEditDialog || openAddDialog}
                    actions={editActions}
                    onRequestClose={() => handleCloseDialog(openEditDialog ? 'edit' : 'add')}
                >
                    <div className='row'>
                        <div>
                            <AutoComplete 
                                name='vessel name'
                                floatingLabelText='Vessel name'
                                searchText={vessel.name}
                                dataSource={vessels}
                                dataSourceConfig={{ text: 'name', value: 'cargo' }}
                                floatingLabelStyle={{fontSize: '13px'}}
                                onUpdateInput={changeVesselAutoComplete}
                                onNewRequest={chooseVesselAutoComplete}
                                filter={AutoComplete.noFilter}
                                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                                style={{marginLeft: '10px', width: '220px'}}
                                popoverProps={{
                                    canAutoPosition: true,
                                }}
                                errorText={!vessel.name && 'Required'}
                                errorStyle={{color: 'red'}}
                                required
                                fullWidth
                            />
                        </div>
                        <div>
                            <SelectField 
                                style={{width: '130px', marginLeft: '10px'}}
                                floatingLabelText='Vessel Type'
                                floatingLabelStyle={{fontSize: '13px'}}
                                maxHeight={400}
                                value={ourGroup}
                                name='Vessel Types'
                                autoWidth={true}
                                errorText={!ourGroup && 'Required'}
                                errorStyle={{color: 'red'}}
                                onChange={handleSelectVesselType}
                            >
                                {
                                    vesselTypes.map(vesselType => {
                                        return (
                                            <MenuItem
                                                key={vesselType}
                                                value={vesselType}
                                                primaryText={vesselType}
                                            />
                                        );
                                    })
                                }
                            </SelectField>
                        </div>
                        <div>
                            <TextField
                                style={{width: '75px', marginLeft: '20px'}}
                                floatingLabelText='DWT'
                                floatingLabelStyle={{fontSize: '13px'}}
                                type='number'
                                value={dwt || ''}
                                errorText={!dwt && 'Required'}
                                errorStyle={{color: 'red'}}
                                onChange={handleChangeDwt}
                            />
                        </div>
                        <div>
                            <TextField
                                style={{width: '75px', marginLeft: '20px'}}
                                floatingLabelText='P D/A'
                                floatingLabelStyle={{fontSize: '13px'}}
                                type='number'
                                errorText={!averagePortCostsUsdDay && 'Required'}
                                errorStyle={{color: 'red'}}
                                value={(averagePortCostsUsdDay && parseInt(averagePortCostsUsdDay).toFixed()) || ''}
                                onChange={handleChangePda}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div>
                            <SelectField 
                                style={{width: '130px', marginLeft: '10px'}}
                                floatingLabelText='Country'
                                floatingLabelStyle={{fontSize: '13px'}}
                                maxHeight={400}
                                value={country._id}
                                name='Countries'
                                autoWidth={true}
                                errorText={!country._id && 'Required'}
                                errorStyle={{color: 'red'}}
                                onChange={handleSelectCountry}
                            >
                                {
                                    countries.map(country => {
                                        return (
                                            <MenuItem
                                                key={country._id}
                                                value={country._id}
                                                primaryText={country.name}
                                            />
                                        );
                                    })
                                }
                            </SelectField>
                        </div>
                        <div>
                            <AutoComplete 
                                name='portName'
                                textFieldStyle={{ fontSize: '16px', marginLeft: '10px' }}
                                style={{ width: '130px' }}
                                floatingLabelText='Port Name'
                                floatingLabelStyle={{ fontSize: '13px' }}
                                hintText='Port name'
                                searchText={port.name}
                                dataSource={ports}
                                dataSourceConfig={{ text: 'name', value: 'item' }}
                                onUpdateInput={changePortName}
                                onNewRequest={choosePort}
                                filter={AutoComplete.noFilter}
                                errorText={!port.name && 'Required'}
                                errorStyle={{color: 'red'}}
                                fullWidth
                                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                                popoverProps={{
                                    canAutoPosition: true,
                                    style: {
                                        width: '300px'
                                    }
                                }}
                            />
                        </div>
                        {
                            shouldShowConfirmCheckbox &&
                            <div>
                                <Checkbox
                                    label="Confirm"
                                    value={approved }
                                    style={{ margin: '40px -25px 0 20px', width: '165px' }}
                                    labelStyle={{ marginLeft: '-7px' }}
                                    onCheck={handleCheckConfirmed}
                                />
                            </div>
                        }
                    </div>
                </Dialog>
            </div>
        );
    }
}

export default EditAddDialog;


// WEBPACK FOOTER //
// ./app/components/Prices/Pda/EditAddDialog.jsx